module.exports = __webpack_public_path__ + "static/media/UGC.acf2686c.png";